export default __webpack_public_path__ + "static/media/RadarTower.256.e81bfe16.png";